/**
 * Saisie d'une prochaine etape : type, date, heure et note. Partagee par la
 * saisie d'un echange, la planification depuis la fiche et la creation d'un
 * lead. Aucune contrainte native (`required`, `min`, `step`) : un navigateur
 * bloquerait l'envoi sans message ; le formulaire parent valide lui-meme.
 */
import type { Ref } from 'react';
import { LIBELLES_INTERACTION, TYPES_PROCHAINE_ETAPE } from '@leads/shared';
import { estTypeProchaineEtape } from '../lib/prochaine-etape';
import type { BrouillonProchaineEtape } from '../lib/prochaine-etape';
import { Champ } from './ui';

export function ChampsProchaineEtape({ valeur, onChange, erreur, refDate }: {
  valeur: BrouillonProchaineEtape;
  onChange: (valeur: BrouillonProchaineEtape) => void;
  /** Erreur de date (absente ou illisible), affichee sous le champ. */
  erreur?: string | null;
  /** Champ de date : celui qui prend le focus quand `erreur` est signalee (`signalerErreursDeChamps`). */
  refDate?: Ref<HTMLInputElement>;
}) {
  const modifier = <C extends keyof BrouillonProchaineEtape>(cle: C, suivante: BrouillonProchaineEtape[C]): void => {
    onChange({ ...valeur, [cle]: suivante });
  };

  return (
    <div className="space-y-3">
      <div className="grid gap-3 sm:grid-cols-[minmax(0,1fr)_10rem_7rem]">
        <Champ libelle="Type d'étape">
          {(id) => (
            <select id={id} className="champ" value={valeur.type}
              onChange={(evenement) => { if (estTypeProchaineEtape(evenement.target.value)) modifier('type', evenement.target.value); }}>
              {TYPES_PROCHAINE_ETAPE.map((type) => <option key={type} value={type}>{LIBELLES_INTERACTION[type]}</option>)}
            </select>
          )}
        </Champ>
        <Champ libelle="Date" erreur={erreur}>
          {(id, decritPar) => (
            <input ref={refDate} id={id} type="date" className="champ" aria-describedby={decritPar} aria-invalid={erreur ? true : undefined}
              value={valeur.date} onChange={(evenement) => modifier('date', evenement.target.value)} />
          )}
        </Champ>
        <Champ libelle="Heure">
          {(id) => <input id={id} type="time" className="champ" value={valeur.heure} onChange={(evenement) => modifier('heure', evenement.target.value)} />}
        </Champ>
      </div>
      <Champ libelle="Note">
        {(id) => (
          <input id={id} className="champ" maxLength={500} placeholder="Rappeler le gérant, envoyer une proposition…"
            value={valeur.note} onChange={(evenement) => modifier('note', evenement.target.value)} />
        )}
      </Champ>
    </div>
  );
}
